import { render } from "./PackingStationPage.vue?vue&type=template&id=1fca6bce&scoped=true&ts=true"
import script from "./PackingStationPage.vue?vue&type=script&lang=ts"
export * from "./PackingStationPage.vue?vue&type=script&lang=ts"

import "./PackingStationPage.vue?vue&type=style&index=0&id=1fca6bce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fca6bce"]])

export default __exports__